module.exports = __webpack_public_path__ + "media/clients/briar-2x-e888f298.jpg";